import moment from "moment";

export const formatDateFunc = (date) => moment(date).format("DD-MMM-YY");

export const checkSameDay = (date) => {
  let newDate = moment(new Date()).format("YYYY-MM-DD");
  let checkDate = moment(date).isSame(newDate, "day");
  return checkDate;
};
   


// WEBPACK FOOTER //
// ./src/utils/dateFormatFunc.js